import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "../../assets/css/--component-payment-method.css";
import secureImg from "../../assets/images/secure-payment-icon.png";
import ConfirmationModal from "../../components/StatusModal";
import { deleteCard, getUserCards, makeCardDefault } from "../../helper/backend-methods";
import { CardImage } from "../../components/CardImage";


const PaymentMethod = () => {
  // JSON data for payment cards
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState(null);

  const [paymentCards, setPaymentCards] = useState([]);



  const getPaymentCards = () => {
    getUserCards().then(({ data }) => {
      if (data.Status) {
        setPaymentCards(data.Data);
      }
    });
  };

  

  useEffect(() => {
    getPaymentCards();
  }, []);

  const toggleConfirmModal = () => setIsConfirmOpen(!isConfirmOpen);

  const handleSetDefault = (Id) => {

    makeCardDefault("?cardId=" + Id).then(({ data }) => {
      if (data.Status) {
        getPaymentCards();
      } 
    });
  };


  const confirmDelete = () => {
    setPaymentCards((cards) => {
      const updatedCards = cards.filter((card) => card.id !== selectedCardId);

      if (updatedCards.length > 0 && !updatedCards.some((card) => card.isDefault)) {
        updatedCards[0].isDefault = true;
      }
      deleteCard("?cardId=" + selectedCardId).then(({ data }) => {
        if (data.Status) {
          getPaymentCards();
        }
      });

      return updatedCards;
    });

    toggleConfirmModal();
  };

  const handleAddCard = () => {
    const newCard = {
      id: Date.now(),
      type: "visa",
      displayName: `Visa ending in **** ${Math.floor(1000 + Math.random() * 9000)}`,
      lastFour: String(Math.floor(1000 + Math.random() * 9000)),
      expiryMonth: new Date().getMonth() + 1,
      expiryYear: new Date().getFullYear() + 3,
      isDefault: false,
      cardHolderName: "John Doe",
    };

    setPaymentCards((prev) => [...prev, newCard]);
  };

  const formatExpiryDate = (month, year) => {
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedYear = year.toString().slice(-2);
    return `${formattedMonth}/${formattedYear}`;
  };

  const getCardBadge = (type) => {
    switch (type.toLowerCase()) {
      case "visa":
        return "VISA";
      case "mastercard":
        return "MC";
      case "discover":
        return "DISC";
      case "amex":
        return "AMEX";
      default:
        return type.toUpperCase();
    }
  };

  const getCardBadgeClass = (type) => {
    switch (type.toLowerCase()) {
      case "visa":
        return "visa";
      case "mastercard":
        return "mastercard";
      case "discover":
        return "discover";
      case "amex":
        return "amex";
      default:
        return "visa";
    }
  };
  
  

  const defaultCard = paymentCards.find((card) => card.Selected);
  const otherCards = paymentCards.filter((card) => !card.Selected);

  return (
    <section id="payment-method-section" className="mt-5 ms-4">
      <div className="d-flex justify-content-between align-items-center payment-container">
        <div>
          <h1 className="fs-30 text-blakish fw-600 mt-0 mb-0">Payment Method</h1>
        </div>
        {/* <button color="primary" className="add-method-btn" onClick={handleAddCard}>
          <i className="ri-add-line me-1"></i>
          ADD PAYMENT METHOD
        </button> */}
      </div>
      <span className="separator my-3" />
      <div className="secure-box mb-4">
        <div className="secure-icon">
          <img src={secureImg} alt="Secure Payment" />
        </div>
        <div>
          <h6 className="secure-title">Your payment information is secure</h6>
          <p className="secure-text">
            We use industry-standard encryption to protect your payment data. Your card details are never stored on our servers.
          </p>
        </div>
      </div>

      {defaultCard && (
        <>
          <h5 className="section-title">Credit Cards</h5>
          <p className="section-desc">Manage your credit cards and payment options. This credit card will be used by default billing.</p>

          <div className="payment-card default-card mb-4">
            <CardBody className="payment-card-body">
              <div className="card-info">
                <span className={`card-badge ${getCardBadgeClass(defaultCard.Scheme)}`}>
                  <CardImage type={defaultCard.Scheme} />
                  </span>

                <div className="card-details">
                  <h6 className="card-title">{defaultCard.Scheme} ending in **** {defaultCard.Last4}</h6>
                  <span className="card-expiry">Card expires at {formatExpiryDate(defaultCard.ExpiryMonth, defaultCard.ExpiryYear)}</span>
                </div>
              </div>

              <div className="card-actions">
                <span className="default-badge me-3">Default</span>
                {/* <i className="ri-edit-line action-icon me-3"></i> */}
                <i
                  className="ri-delete-bin-line action-icon"
                  onClick={() => {
                    setSelectedCardId(defaultCard.CardId);
                    toggleConfirmModal();
                  }}
                  style={{ cursor: "pointer" }}
                ></i>
              </div>
            </CardBody>
          </div>
        </>
      )}

      {otherCards.length > 0 && (
        <>
          <h5 className="section-title">Other Cards</h5>
          <Row className="cards-list">
            {otherCards.map((card) => (
              <Col md={6} key={card.CardId} className="card-list-column">
                <div className="payment-card mb-4">
                  <CardBody className="payment-card-body">
                    <div className="card-info">
                      <span className={`card-badge ${getCardBadgeClass(card.Scheme)}`}>
                        <CardImage type={card.Scheme} />
                      </span>

                      <div className="card-details">
                        <h6 className="card-title">{card.Scheme} ending in **** {card.Last4}</h6>
                        <span className="card-expiry">Card expires at {formatExpiryDate(card.ExpiryMonth, card.ExpiryYear)}</span>
                      </div>
                    </div>

                    <div className="card-actions">
                      <button className="set-default-btn me-3" onClick={() => handleSetDefault(card.CardId)}>
                        Set as default
                      </button>
                      {/* <i className="ri-edit-line action-icon me-3"></i> */}
                      <i
                        className="ri-delete-bin-line action-icon"
                        onClick={() => {
                          setSelectedCardId(card.CardId);
                          toggleConfirmModal();
                        }}
                        style={{ cursor: "pointer" }}
                      ></i>
                    </div>
                  </CardBody>
                </div>
              </Col>
            ))}
          </Row>
        </>
      )}

      {paymentCards.length === 0 && (
        <div className="text-center py-5">
          <p className="text-muted">No payment methods added yet.</p>
          {/* <Button color="primary" onClick={handleAddCard}>
            <i className="ri-add-line me-1"></i>
            Add Your First Payment Method
          </Button> */}
        </div>
      )}
      <ConfirmationModal
        isOpen={isConfirmOpen}
        toggle={toggleConfirmModal}
        type="error"
        title="Delete Payment Method"
        message="Are you sure you want to delete this payment method?"
        ButtonText="Cancel"
        ButtonTextYes="Delete"
        onCancel={toggleConfirmModal}
        onYes={confirmDelete}
        isShowYesButton={true}
      />
    </section>
  );
};

export default PaymentMethod;
